export default class TableHead {
  constructor(label, key, cssClass = '') {
    this.label = label;
    this.key = key;
    this.class = cssClass;
  }
}
